import { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { GraduationCap, ArrowLeft, Envelope, CheckCircle } from "@phosphor-icons/react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  async function submit(e) {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/auth/password-reset/request", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Erro");
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#F7F3EE] relative overflow-hidden">
      <div className="blob w-[500px] h-[500px] bg-[#FFB86B]/60 -top-40 -left-40" />
      <div className="blob w-[400px] h-[400px] bg-[#1E5FFF]/30 bottom-0 right-0" />

      <div className="w-full max-w-md card-elevated rounded-3xl p-6 sm:p-8 relative z-10">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 rounded-2xl gradient-primary flex items-center justify-center shadow-lg">
            <GraduationCap size={22} color="white" weight="duotone" />
          </div>
          <div>
            <div className="font-heading font-black text-base leading-none">Caminhos</div>
            <div className="text-[10px] uppercase tracking-widest font-bold text-zinc-500">APP</div>
          </div>
        </div>

        {sent ? (
          <div className="text-center py-6">
            <div className="w-16 h-16 rounded-full bg-[#EAF7EF] flex items-center justify-center mx-auto mb-4">
              <CheckCircle size={32} weight="duotone" color="#12B76A" />
            </div>
            <h1 className="font-heading text-2xl font-black text-[#12143A]">Verifique seu email</h1>
            <p className="text-sm text-zinc-600 mt-2 leading-relaxed">
              Se existe uma conta com <b>{email}</b>, enviamos um link para redefinir sua senha. O link expira em 30 minutos.
            </p>
            <Link to="/login" className="mt-6 inline-flex items-center gap-1 text-sm font-semibold text-[#1E5FFF] hover:underline">
              <ArrowLeft size={14} /> Voltar para o login
            </Link>
          </div>
        ) : (
          <>
            <div className="pill-badge bg-[#E0EBFF] text-[#1E5FFF] mb-4"><Envelope size={11} weight="fill" /> Recuperação</div>
            <h1 className="font-heading text-3xl font-black text-[#12143A] leading-tight">Esqueceu sua senha?</h1>
            <p className="text-sm text-zinc-600 mt-2">Informe seu email e enviaremos um link para você criar uma nova senha.</p>
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <Label className="text-xs font-bold text-zinc-500 uppercase tracking-wider">Email</Label>
                <Input data-testid="forgot-email" type="email" value={email} required
                       onChange={e => setEmail(e.target.value)} placeholder="voce@escola.com"
                       className="mt-2 h-14 rounded-2xl border-zinc-200 bg-white focus:border-[#1E5FFF] focus-visible:ring-[#1E5FFF]/20 text-base" />
              </div>
              <Button data-testid="forgot-submit" type="submit" disabled={loading}
                      className="w-full h-14 rounded-2xl gradient-primary hover:opacity-90 text-white font-bold shadow-[0_10px_30px_rgba(30,95,255,0.35)]">
                {loading ? "Enviando…" : "Enviar link de redefinição"}
              </Button>
              <Link to="/login" className="mt-2 inline-flex items-center gap-1 text-sm text-zinc-500 hover:text-[#1E5FFF]">
                <ArrowLeft size={14} /> Voltar para o login
              </Link>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
